import validate from "/app/node_modules/.pnpm/nuxt@3.3.3_@types+node@18.19.3_rollup@3.29.4_sass@1.69.5_terser@5.39.0_typescript@4.9.5/node_modules/nuxt/dist/pages/runtime/validate.js";
export const globalMiddleware = [
  validate
]
export const namedMiddleware = {
  "api-proxy": () => import("/app/src/client/middleware/api-proxy.ts"),
  "auto-login": () => import("/app/src/client/middleware/autoLogin.ts"),
  "block-route": () => import("/app/src/client/middleware/block-route.ts"),
  "event-page-layout": () => import("/app/src/client/middleware/eventPageLayout.ts"),
  "page-slide": () => import("/app/src/client/middleware/page-slide.ts"),
  "set-intro": () => import("/app/src/client/middleware/setIntro.ts"),
  "set-page-layout": () => import("/app/src/client/middleware/setPageLayout.ts"),
  "toc-route-middleware": () => import("/app/src/client/middleware/toc-route-middleware.ts")
}